module.exports = {
      id: "cbedc37175b7bdf4acc3bdec3cc1a653state-before-reconstruction.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#cbedc37175b7bdf4acc3bdec3cc1a653state-before-reconstruction.svg",
      toString: function () {
        return this.url;
      }
    }